import React from 'react';
import { withRouter, connect, MujiLink } from '@souche-f2e/muji';
import { List, Typography, Button } from 'antd';
import { dispatch } from '@@/store';

@withRouter
class DocsGroup extends React.Component {
  constructor() {
    super();
    this.groupId = null;
  }

  render() {
    const groupId = this.props.router.currentRoute.params.id;
    if(groupId && groupId !== this.groupId) {
      dispatch.docs.fetchGroupApis({ groupId });
      this.groupId = groupId;
    }

    const { group } = this.props;
    if(!group) {
        return (
          <div>载入中...</div>
        )
    }

    if(group && group.msg) {
      return (
        <div>{group.msg}</div>
      )
    }

    let start = 1;

    return (
      <div>
        <h3 style={{ marginBottom: '16px' }}>{group.name}</h3>
        <p style={{ borderLeft: '4px solid #42b983', paddingLeft: '12px' }}>{ group.description }</p>
        <List
          header={<div>API 列表</div>}
          bordered
          dataSource={group.apis}
          renderItem={item => (
            <List.Item style={{ marginLeft: '16px' }}>
              <MujiLink to={`/documents/docs/api/${item.id}?groupId=${group.id}`} style={{ color: 'rgba(0, 0, 0, 0.65)' }}>
                <span>{start++}. {item.name}</span>
                <span style={{ color: 'green', marginLeft: '8px' }}>></span>
              </MujiLink>
            </List.Item>
          )}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const docs = state.docs;
  return {
    group: docs.group
  }
}

export default connect(mapStateToProps)(DocsGroup);
